// extracted by mini-css-extract-plugin
module.exports = {"main":"ToggleSearchDropdown_main__xGW13","search-fade-in":"ToggleSearchDropdown_search-fade-in__oG_2m"};